import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectGlobalState } from "../state-management/selectors";
import * as Icons from "../assets/SVGs/index";
import Container from "../components/basicComponents/container";
import TextInput from "../components/basicComponents/text-input";
import Select from "../components/basicComponents/select";
import TextArea from "../components/basicComponents/text-area";
import ToggleSwitch from "../components/basicComponents/switch-box";
import Button from "../components/basicComponents/button";
import {
  setAlert,
  setAlertContext,
  setAlertSeverity,
} from "../state-management/actions/alerts-actions";
import {
  addCooperation,
  getCooperations,
  removeCooperation,
  editCooperation,
} from "../state-management/actions/cooperation-actions";
import { CooperationProps } from "../types/public";
import Grid from "../components/grid";
import { setRowStatus } from "../state-management/actions/global-state-actions";
import { RemovePermission } from "../utils/remove-permission";
import { getCooperationsReq } from "../state-management/actions/cooperation-requset-actions";

const initialData: CooperationProps = {
  title: "",
  department_id: "",
  description: "",
  requierments: "",
  benefits: "",
  created_by: "",
  is_active: false,
  urgency: false,
  full_time: false,
  part_time: false,
  hybrid: false,
  remote: false,
};

export default function Cooperation() {
  const dispatch = useDispatch();
  const { departmentsData, groupingData, currentUserData } =
    useSelector(selectGlobalState);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const [newData, setNewData] = useState<CooperationProps>({
    ...initialData,
    created_by: currentUserData._id,
  });
  const [cooperationsData, setCooperationsData] = useState<any>([]);
  const [cooperationReqs, setCooperationsReqs] = useState<any>([]);
  const [departmentOptions, setDepartmetOptions] = useState([
    { label: "", value: "" },
  ]);
  const [editable, setEditable] = useState<boolean>(false);

  const permissionDepartment = groupingData.find(
    (item: any) => item.user_id === currentUserData._id
  )?.department_id || ["none"];

  const fetchData = async () => {
    try {
      const response = await getCooperations()(dispatch);
      setCooperationsData(response.data);
      const coopReqs = await getCooperationsReq()(dispatch);
      setCooperationsReqs(coopReqs.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setDepartmetOptions(
      departmentsData
        .filter((item: any) => permissionDepartment.includes(item._id))
        .map((dep: any) => ({
          label: dep.name,
          value: dep._id,
        }))
    );
    fetchData();
  }, []);

  const handleSubmit = async () => {
    try {
      const response = await addCooperation(newData)(dispatch);
      if (response.data) {
        fetchData();
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("success"));
        dispatch(setAlertContext(" کاربر مربوطه اضافه شد"));
        setNewData(initialData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleToggleChange = (name: string, checked: boolean) => {
    setNewData((prev: CooperationProps) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleDelete = async (id: string) => {
    try {
      const userExists = RemovePermission(id, [cooperationReqs]);
      if (!userExists) {
        const response = await removeCooperation(id)(dispatch);
        if (response.data) {
          fetchData();
          dispatch(setAlert(true));
          dispatch(setAlertSeverity("success"));
          dispatch(setAlertContext(" آگهی مربوطه حذف شد"));
        }
      } else {
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("warning"));
        dispatch(setAlertContext(" آگهی مربوطه دارای وابستگی است  "));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSetEditData = async (clear: boolean, id: any) => {
    const setData = cooperationsData.find((item: any) => item._id === id);
    if (!clear && cooperationsData) {
      setNewData(setData);
      setEditable(true);
    }
    if (clear) {
      setNewData(initialData);
      setEditable(false);
    }
  };

  const handleEdit = async () => {
    try {
      const { _id, ...updateData } = newData;
      const response = await editCooperation(_id, updateData)(dispatch);
      if (response.data) {
        fetchData();
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("success"));
        dispatch(setAlertContext(" آگهی مربوطه ویرایش شد"));
        setEditable(false);
        setNewData(initialData);
      }
    } catch (error) {
      console.log(error);
    }
    dispatch(setRowStatus("clear id", false));
  };
  return (
    <div className="flex flex-col items-center w-full">
      <Container header="ثبت آگهی">
        <div
          className="flex flex-col md:gap-y-5 gap-y-2 w-full"
          style={{ marginTop: "30px", gap: "10px" }}
        >
          <div className="flex gap-x-4">
            <TextInput
              name="title"
              value={newData.title}
              placeholder="موضوع را وارد کنید"
              onChange={(e) => {
                setNewData((prev) => ({
                  ...prev,
                  title: e.target.value,
                }));
              }}
              label={`موضوع `}
              RightIcon={<Icons.FaqIcon className="w-5 h-5" />}
            />
            <Select
              name="departments"
              options={departmentOptions}
              value={newData.department_id}
              onChange={(e) => {
                setNewData((prev) => ({
                  ...prev,
                  department_id: e.target.value,
                }));
              }}
              placeholder="انتخاب دسته بندی"
              className="border"
            />
          </div>
          <TextArea
            name="description"
            value={newData.description}
            placeholder="توضیحات"
            onChange={(e) => {
              setNewData((prev) => ({
                ...prev,
                description: e.target.value,
              }));
            }}
            rows={4}
          />
          <div className=" flex gap-x-4">
            <div className="w-full">
              <TextArea
                name="الزامات"
                value={newData.requierments}
                placeholder="الزامات"
                onChange={(e) => {
                  setNewData((prev) => ({
                    ...prev,
                    requierments: e.target.value,
                  }));
                }}
                rows={4}
              />
            </div>
            <div className="w-full">
              <TextArea
                name="مزایا"
                value={newData.benefits}
                placeholder="مزایا"
                onChange={(e) => {
                  setNewData((prev) => ({
                    ...prev,
                    benefits: e.target.value,
                  }));
                }}
                rows={4}
              />
            </div>
          </div>
          <div className="w-full flex gap-6 flex-wrap justify-start items-center">
            <ToggleSwitch
              name="is_active"
              label=" وضعیت نمایش"
              checked={newData.is_active}
              onChange={(checked) => handleToggleChange("is_active", checked)}
            />
            <ToggleSwitch
              name="urgency"
              label="فوری"
              checked={newData.urgency}
              onChange={(checked) => handleToggleChange("urgency", checked)}
            />
            <ToggleSwitch
              name="full_time"
              label="تمام وقت"
              checked={newData.full_time}
              onChange={(checked) => handleToggleChange("full_time", checked)}
            />
            <ToggleSwitch
              name="part_time"
              label="پاره وقت"
              checked={newData.part_time}
              onChange={(checked) => handleToggleChange("part_time", checked)}
            />
            <ToggleSwitch
              name="hybrid"
              label="ترکیبی"
              checked={newData.hybrid}
              onChange={(checked) => handleToggleChange("hybrid", checked)}
            />
            <ToggleSwitch
              name="remote"
              label="دورکار"
              checked={newData.remote}
              onChange={(checked) => handleToggleChange("remote", checked)}
            />
          </div>
        </div>
        <div className="mt-6">
          <Button
            ref={buttonRef}
            variant={editable ? "edit" : "success"}
            title={editable ? "ویرایش" : "ثبت"}
            paddingx="20px"
            paddingy="6px"
            onClick={editable ? handleEdit : handleSubmit}
          />
        </div>
      </Container>
      <Container header="لیست آگهی ها">
        <Grid
          height={500}
          columns={[
            { headerName: "عنوان", field: "title" },
            {
              headerName: "دپارتمان",
              valueGetter: (params: any) =>
                departmentsData.find(
                  (dep: any) => dep._id === params.data?.department_id
                )?.name || "",
            },
            { headerName: "انتشار", field: "is_active" },
            { headerName: "فوری", field: "urgency" },
            { headerName: "تمام وقت", field: "full_time" },
            { headerName: "پاره وقت", field: "part_time" },
            { headerName: "ترکیبی", field: "hybrid" },
            { headerName: "دور کار", field: "remote" },
          ]}
          userData={cooperationsData}
          pageSize={50}
          pagination={true}
          editBtn={true}
          deleteBtn={true}
          editable={false}
          handleDelete={handleDelete}
          handleSetData={handleSetEditData}
          btnHeader="عملیات"
        />
      </Container>
    </div>
  );
}
